define('HomepagePopUp.EntryPoint', [
  'HomepagePopUp.View'
],
function (
  HomepagePopUpView
) {
  'use strict';

  return {
    mountToApp: function mountToApp(container) {
      var layout = container.getComponent('Layout');
      var environment = container.getComponent('Environment');
      if (environment) {
        var popUpConfig = environment.getConfig('HomepagePopUp');

        if (layout && popUpConfig && popUpConfig.activeDeactivate
                        && window.location.pathname === '/' && window.location.search.indexOf('fragment') === -1) {
          var modalView = new HomepagePopUpView({
            container: container,
            popUpConfig: popUpConfig
          });

          layout.on('afterShowContent', function () {
            layout.showContent(modalView, { showInModal: true, options: { className: 'uc-pop-up-modal' } });
          });
        }
      }
    }
  };
});
